import { render, staticRenderFns } from "./ParameterList.vue?vue&type=template&id=b2a88416&"
import script from "./ParameterList.vue?vue&type=script&lang=js&"
export * from "./ParameterList.vue?vue&type=script&lang=js&"
import style0 from "./ParameterList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports